import globals from './Globals';

const canvas = document.getElementById('canvas');
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

const stage = new createjs.Stage('canvas');

globals.width = canvas.width;
globals.height = canvas.height;

if (createjs.Touch.isSupported()) {
  createjs.Touch.enable(stage, true);
}

export { stage as default };
